import './App.css';
import Header from './Components/Header';
import Aboutme from './Components/Aboutme';
import Projects from './Components/Projects';
import Button from './Components/Button';



function App() {

  return (
    <>
      <Header />
      <Button />
      
      <Aboutme />
      <Projects />
    </>
  );
}

export default App;


